"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var ShowUser = require("../core/gql/queries/show-user");
var constants_1 = require("../core/constants");
require("./toolbar.scss");
var OrgToolbar = function (_a) {
    var _b, _c;
    var Link = _a.Link;
    var showUser = react_apollo_1.useQuery(ShowUser.QUERY);
    var user = (_b = showUser.data) === null || _b === void 0 ? void 0 : _b.user;
    var helpBody = (React.createElement("div", { style: { minWidth: "100px" } },
        React.createElement("div", { className: "u-padSm" }, "What's New"),
        React.createElement("div", { className: "u-padSm" }, "Help & Support")));
    var accountBody = React.createElement(React.Fragment, null,
        React.createElement("div", { style: { minWidth: "100px" }, className: "u-padSm" },
            React.createElement("div", null, user === null || user === void 0 ? void 0 :
                user.firstName,
                " ", user === null || user === void 0 ? void 0 :
                user.lastName),
            React.createElement("div", { className: "u-colorNeutral8 u-fontSizeXs" }, user === null || user === void 0 ? void 0 : user.email)),
        React.createElement("div", { className: "u-padSm toolbar-item" },
            React.createElement("a", { href: constants_1.TEAMSNAP_URL + "/team/dashboard" }, "TeamSnap Dashboard")),
        React.createElement("div", { className: "u-padSm toolbar-item" },
            React.createElement("a", { href: "" + constants_1.ACCOUNTS_URL }, "My Account")),
        React.createElement("div", { className: "u-padSm toolbar-item" },
            React.createElement("a", { href: constants_1.TEAMSNAP_URL + "/account?view=clubs" }, "Billing and Plans")),
        React.createElement("div", { className: "u-padSm toolbar-item", style: { borderTop: "1px solid #ccc" } },
            React.createElement("a", { href: constants_1.TEAMSNAP_URL + "/login/signout" }, "Sign Out")));
    var adminBody = (React.createElement("div", { style: { minWidth: "100px" } },
        React.createElement("div", { className: "toolbar-item u-padSm" },
            React.createElement("a", { href: "" + constants_1.CLASSIC_ADMIN_URL }, "Go to Admin")),
        React.createElement("div", { className: "toolbar-item u-padSm" },
            React.createElement(Link, { to: "/employee/organizations" }, "Employee Portal"))));
    return (React.createElement(teamsnap_ui_1.Toolbar, { showSearch: false, showAccount: true, showAdmin: (_c = showUser.data) === null || _c === void 0 ? void 0 : _c.user.isAdmin, showHelp: false, helpBody: helpBody, accountBody: accountBody, adminBody: adminBody }));
};
exports.default = OrgToolbar;
//# sourceMappingURL=toolbar.js.map